import React from 'react';
import ShowOnlyPendingRequestsCheckbox from 'views/pages/manage/unAssigned/studentFinanceApproval/paymodeApproval/ShowOnlyPendingRequestsCheckbox';
import AFilterForm from 'components/AFilterForm/AFilterForm';
import { EMPTY_FILTER_FORM, getFilterFormFields } from './constant';
const Filters = ({
    setFilterForm,
    dropdownData,
    filterForm,
    handleFilterForm,
    applyFilterHandler
}) => {

    return (
        <div className='d-flex' style={{ gap: '0.75rem' }}>

            <ShowOnlyPendingRequestsCheckbox
                checked={filterForm?.status === 'ACTIVE'}
                styles={{ marginTop: '0px' }}
                label="Show only active"
                showOnlyPendingRequestsHandler={(checked) => {
                    const updatedForm = {
                        ...filterForm,
                        status: checked ? 'ACTIVE' : ""
                    };

                    handleFilterForm('status', checked ? 'ACTIVE' : "");
                    applyFilterHandler(updatedForm);
                }}
            />

            <div style={{ marginTop: "3%" }}>
                <AFilterForm
                    formFields={getFilterFormFields(dropdownData, filterForm)}
                    filterForm={filterForm}
                    handleFilterForm={handleFilterForm}
                    applyFilterHandler={applyFilterHandler}
                    removeFilterHandler={() => {
                        setFilterForm(EMPTY_FILTER_FORM);
                        applyFilterHandler(EMPTY_FILTER_FORM);
                    }}
                />
            </div>
        </div>
    );
}

export default Filters